import { Box, ThemeProvider, Typography, createTheme } from "@mui/material";
import createPalette from "@mui/material/styles/createPalette";
import React, { ReactNode } from "react";
import { vars } from "../Variables";

const {
  secondaryFont,
  secondaryColor,
  leftPanelBg,
} = vars;

export interface ILeftPanel {
  icon?: string;
  text?: string;
  children?: ReactNode;
}

declare module '@mui/material/styles' {
  interface Theme { }
  // allow configuration using `createTheme`
  interface ThemeOptions { }
}

const customPalette = createPalette({
  primary: {
    main: leftPanelBg
  },
  secondary: {
    main: secondaryColor,
  }
})

const theme = createTheme({
  typography: {
    fontFamily: secondaryFont,

    body1: {
      fontSize: '18px',
      lineHeight: '133%',
      fontWeight: 300,
      color: `${customPalette.secondary.main} !important`
    },

    body2: {
      fontSize: '18px',
      lineHeight: '133%',
      fontWeight: 600,
      color: `${customPalette.secondary.main} !important`
    }
  }
});

export const LeftPanel: React.FC<ILeftPanel> = (props) => {
  const { icon, children } = props;
  const classes = {
    root: {
      background: customPalette.primary.main,
      height: '100vh',
      textAlign: 'center',
    }
  }
  return (
    <ThemeProvider theme={theme}>
      <Box
        flexDirection='column'
        alignItems='center'
        justifyContent='center'
        display='flex'
        p={10}
        sx={classes.root}
      >

        <Box>
          <Box mb={5.5}>
            {children}
          </Box>

          <img src={icon} alt="steps-icon" />
        </Box>
      </Box>
    </ThemeProvider>
  )
};